// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookFeed-module__spoiler--fNLvV {
  width: fit-content;
  display: inline-block;
  padding: 0 1px;
  background-image: linear-gradient(to bottom, transparent 45%, #f5dfa0 45%);
  border-radius:  3px;
  filter: blur(0.1px);
}`, "",{"version":3,"sources":["webpack://./src/pages/BookFeedPage/components/BookFeed/BookFeed.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,0EAA0E;EAC1E,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".spoiler {\n  width: fit-content;\n  display: inline-block;\n  padding: 0 1px;\n  background-image: linear-gradient(to bottom, transparent 45%, #f5dfa0 45%);\n  border-radius:  3px;\n  filter: blur(0.1px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spoiler": `BookFeed-module__spoiler--fNLvV`
};
export default ___CSS_LOADER_EXPORT___;
